module.exports = __webpack_public_path__ + "static/media/instagram-social-media-svgrepo-com (2).c124107a.svg";